import { REPORT } from "../_constants/actionConstants";
import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { DOCTYPE } from "../_constants/docTypeConstants";
import { getUUID } from "../_utils/generalUtils";
import { actionScripts } from "../_helpers/actionScripts";

export const createReport = (tabIdCheckoutToken, queryParams) => (dispatch, getState) =>
  new Promise((resolve) => {
    dispatch({ type: REPORT.CREATE });
    let apiEndpoint = BASE_URL + "/api/Reports/";
    switch (queryParams.reportType) {
      case DOCTYPE.REPORT_LABOR_WEEKLY:
        apiEndpoint += "GenerateLaborWeeklyReport";
        break;
      case DOCTYPE.REPORT_CONTRACTOR_WEEKLY:
        apiEndpoint += "GenerateContractorWeeklyReport";
        break;
      case DOCTYPE.REPORT_ITEM_EST_QUANTITIES:
        apiEndpoint += "GenerateItemEstimatedQuantitiesReport";
        break;
      case DOCTYPE.REPORT_COMMENT_KEYWORD:
        apiEndpoint += "GenerateCommentKeywordReport";
        break;
      case DOCTYPE.REPORT_WORK_PERFORMED:
        apiEndpoint += "GenerateWorkPerformedReport";
        break;
      default:
        break;
    }
    axios
      .post(apiEndpoint, queryParams)
      .then((response) => {
        const tabId = getState().mainTabs.reservedTabIds[tabIdCheckoutToken];
        dispatch({
          type: REPORT.CREATE_FULFILLED,
          report: { ...response.data, queryParams },
          tabId,
        });
        console.log(REPORT.CREATE_FULFILLED, response.data);
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = REPORT.CREATE_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(REPORT.CREATE_REJECTED, err.response.data);
      });
  });

export const downloadItemEstimatedQuantitiesData =
  (queryParams) => async (dispatch, getState) => {
    dispatch({ type: REPORT.DOWNLOAD });

    const apiEndpoint = `${BASE_URL}/api/Reports/ItemEstimatedQuantities/Csv`;
    try {
      const fileRes = await axios.post(apiEndpoint, queryParams, {
        responseType: "blob",
      });
      dispatch({ type: REPORT.DOWNLOAD_FULFILLED });

      const fileName = fileRes.headers["content-disposition"]
        .split("filename=")[1]
        .split(";")[0]
        .trim();
      const pdfFileBlob = new Blob([fileRes.data], { type: "text/csv" });

      const url = URL.createObjectURL(pdfFileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      return;
    } catch (err) {
      // If error, do not show error msg, to allow re-attempt of client-side
      // PDF generation.
      dispatch({ type: REPORT.DOWNLOAD_REJECTED });
      console.error("Report download failed.", err);
      return Promise.reject(err);
    }
  };
